module.exports = __webpack_public_path__ + "static/media/google.2de36850.png";